export const columnConverter = (columnsInfo) =>
columnsInfo.map(({ headerKey,formulaKey, header, symbol = "", type, unit, options }) => ({
    id: headerKey,
    accessorKey: headerKey,
    formulaKey: formulaKey,
    header: header + symbol,
    meta: {
      type,
      unit,
      ...options
    },
  }));

export default columnConverter;
